import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Participation.module.css';
import { DBDropDownObjective, DBTextFieldObjective } from '_components';

class PatientCareCenterNoteWpSubjectiveParticipation extends React.Component {

    render() {
        let participationOptions = [
            { id: 1, value: 'Good' },
            { id: 2, value: 'Fair' },
            { id: 3, value: 'Poor' }
        ];

        return (
            <PatientCareCenterNoteSection id='sub_participation' name='Participation in Program' level={5}>
                <div className={styles.row}>
                <label className={styles.label}>Motivation:</label>
                    <DBDropDownObjective
                        className={styles.rating_drop_down}
                        noteId={this.props.noteId}
                        entity={this.props.table}
                        entityKeyColumn={this.props.prefix + 'NO'}
                        entityKeyValue={this.props.pk}
                        field={this.props.prefix + 'SUBPARTMOTIV'}
                        customOptions={participationOptions}
                    />
                         
                    <label className={styles.comment_label}>Comments:</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        className={styles.comment}
                        entity={this.props.table}
                        entityKeyColumn={this.props.prefix + 'NO'}
                        entityKeyValue={this.props.pk}
                        field={this.props.prefix + 'SUBPARTMOTIVTXT'}
                    />
               
                </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let pk = parseInt(noteId.split("_")[1]);
    let prefix = 'NT';
    let table = 'PTNOTE';

    return {
        noteId,
        pk,
        prefix,
        table
    };
}
const connectedPatientCareCenterNoteWpSubjectiveParticipation = connect(mapStateToProps)(PatientCareCenterNoteWpSubjectiveParticipation);
export { connectedPatientCareCenterNoteWpSubjectiveParticipation as PatientCareCenterNoteWpSubjectiveParticipation };

